export default __webpack_public_path__ + "static/media/foto10_pexels-tima-miroshnichenko-7009473.14decfe5.jpg";